import type { Map as MapLibreMap } from 'maplibre-gl';
import { recordSensorScale } from './sensor-scale-readout';

/** Publish the resolved pose after terrain corrections and the final map paint. */
export function recordCameraReadout(map: MapLibreMap): void {
  const data = map.getCanvas().dataset;
  data.cameraPitch = String(map.getPitch());
  data.cameraZoom = String(map.getZoom());
  data.cameraBearing = String(map.getBearing());
  if (map.getVerticalFieldOfView) data.cameraFieldOfView = String(map.getVerticalFieldOfView());
  if (typeof map.getRoll === 'function') data.cameraRoll = String(map.getRoll());
  data.cameraCenter = JSON.stringify(map.getCenter().toArray());
  recordSensorScale(map);
}
